<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="submitLogin">
        <card class="card-login card-white">
          <template slot="header">
            <img src="img/card-primary.png" alt="" />
            <h1 class="card-title">Reset password</h1>
          </template>
          <template v-if="resettingPassword !== 'resetted'">
            <div>
              <label for="">Inserisci la mail di login</label>
              <base-input
                v-validate="'required|email'"
                name="email"
                :error="getError('email')"
                v-model="model.email"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
              >
              </base-input>

            </div>

            <div slot="footer">
              <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                RESET PASSWORD
              </base-button>
              <div class="text-center">
                <h6>
                  <router-link class="link footer-link" to="/login">
                    Torna al login
                  </router-link>
                </h6>
              </div>
            </div>
          </template>
          <template v-else>
            <h3 class="text-primary font-weight-bold">Ti abbiamo inviato un link per e-mail, dal quale potrai scrivere la tua nuova password</h3>

            <h6>
              <router-link class="link footer-link text-primary" to="/login">
                <u>Torna al login</u>
              </router-link>
            </h6>
          </template>
        </card>
      </form>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      model: {
        email: '',
      }
    };
  },
  computed: {
    ...mapState('account', ['resettingPassword'])
  },
  created () {
    // reset login status
    this.logout();
  },
  methods: {
    ...mapActions('account', ['resetPassword', 'logout']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async submitLogin() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        this.resetPassword(this.model.email);
        // TIP use this.model to send it to api and perform login call

      }
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
